import {
  APP_AUTH,
  APP_LOGIN,
  APP_PIN_ENTER,
  APP_CHANGE_CURRENT_PASSWORD,
  CURRENT_USER_CODE,
  TOKEN_KEY,
} from "@/AppConfig";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { TokenDecodedProps, ValidateReq, ValidateRes } from "./types";
import { VALIDATE_MENU_PATH_URL } from "./constants";
import { useTheme } from "@mui/material";
import { FetchParamDataProps } from "@/views/configurations/uiConfig/forms/stepReportType/types";
import { MutationFunction } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function setLocalStoage(key: string, value: string) {
  localStorage.setItem(key, value);
}

export function getLocalStorage(key: string): string | null {
  return localStorage.getItem(key);
}
export function clearLocalStorage() {
  localStorage.removeItem(TOKEN_KEY);
}

/** unsaved work (e.g. sales order drafts) that must outlive a logout */
const KEEP_ON_CLEAR = ['erps.soDraft.', 'academy.'];

/** clears the session from localStorage but keeps unsaved drafts */
export function clearLocalStorageKeepDrafts() {
  Object.keys(localStorage)
    .filter((k) => !KEEP_ON_CLEAR.some((prefix) => k.startsWith(prefix)))
    .forEach((k) => localStorage.removeItem(k));
}

export function checkAuth(): boolean {
  return Boolean(getLocalStorage(TOKEN_KEY));
}

export function checkDeviceRemember(): boolean {
  return Boolean(getLocalStorage(CURRENT_USER_CODE));
}

export function decodeJWT(jwt: string) {
  return jwtDecode(jwt);
}

export function removeHeadertoken() {
  delete axios.defaults.headers.common["X-Access-Key"];
}

export function getLogoutPath(): string {
  const isDeviceRemembered = checkDeviceRemember();
  if (isDeviceRemembered) {
    return APP_AUTH + APP_PIN_ENTER;
  } else {
    return APP_AUTH + APP_LOGIN;
  }
}
export function ChangeCurrentPassword(): string {
  return APP_AUTH + APP_CHANGE_CURRENT_PASSWORD;
  // const isDeviceRemembered = checkDeviceRemember();
  // if (isDeviceRemembered) {
  //   return APP_AUTH + APP_CHANGE_CURRENT_PASSWORD;
  // } else {
  //   return APP_AUTH + APP_CHANGE_CURRENT_PASSWORD;
  // }
}
export function generateRandomColor() {
  // Generate a random color in hexadecimal format
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}


export function setCommonStorage(jwt: string): any {
  setLocalStoage(TOKEN_KEY, jwt);
  const decodedValue = decodeJWT(jwt) as TokenDecodedProps;
  setLocalStoage(CURRENT_USER_CODE, decodedValue.user_code);
  return decodedValue;
}

export function customAvatar(name: string) {
  const theme = useTheme();
  return {
    style: { backgroundColor: theme.palette.primary.main },
    children: name ? name.charAt(0) : "",
    src: "/static/images/avatar/1.jpg",
  };
}

export const extractProcedureName = (fullProcedureString: string): string => {
  const procName = fullProcedureString.split("(")[0];
  return procName.trim();
};
export const generateProcedureString = (
  procedureName: string,
  paramList: FetchParamDataProps[]
): string => {
  const paramNames = paramList
    ? paramList.map((param) => `:${param.ARGUMENT_NAME}`).join(", ")
    : [];
  return `${procedureName}(${paramNames})`;
};
export function hasProcedureChanged(oldProc: string, newProc: string): boolean {
  const extractProcedureDetails = (proc: string) => {
    const [name, params] = proc.split("(");
    const paramList = params
      ? params
          .replace(")", "")
          .split(",")
          .map((param) => param.trim())
          .sort()
      : [];
    return {
      name: name.trim(),
      params: paramList,
    };
  };
  const oldProcDetails = extractProcedureDetails(oldProc);
  const newProcDetails = extractProcedureDetails(newProc);

  const nameChanged = oldProcDetails.name !== newProcDetails.name;
  const paramsChanged =
    oldProcDetails.params.length !== newProcDetails.params.length ||
    oldProcDetails.params.some(
      (param, index) => param !== newProcDetails.params[index]
    );


  return nameChanged || paramsChanged;
}

export const validateMenuPathForEmployee: MutationFunction<
  AxiosResponse<ValidateRes>,
  ValidateReq
> = async (payload: ValidateReq) => {
  try {
    const response = await axios.post<any>(VALIDATE_MENU_PATH_URL, payload);

    return response.data;
  } catch (error: any) {
    // no answer / gateway or server error: the server is unavailable, which says nothing about the user's rights
    const status = error?.response?.status ?? 0;
    throw Object.assign(new Error(error.response?.data?.message), { unavailable: !error?.response || status >= 500 });
  }
};
